import { useEffect } from 'react';

import {
  clearBuyTicketsPageSessionStorage,
  getBuyTicketsPageSessionStorage,
} from '../utils/reloadBuyTicketsPageSessionStorage';

const ParamsKeys = {
  Edit: 'edit',
  Date: 'date',
  Flow: 'flow',
};

export const useReloadSessionStorage = () => {
  useEffect(() => {
    if (!window) return;

    const { flow, date } = getBuyTicketsPageSessionStorage();

    if (flow && date) {
      const url = new URL(window.location.href);
      url.searchParams.set(ParamsKeys.Edit, 'true');
      url.searchParams.set(ParamsKeys.Date, date);
      url.searchParams.set(ParamsKeys.Flow, flow);

      clearBuyTicketsPageSessionStorage();

      window.history.replaceState(null, '', url);
    }
  }, []);
};
